export const ACTION = {
  REQUEST_RUN: "AI_CHAT_ASSISTANT:REQUEST_RUN",
  FAIL_RUN: "AI_CHAT_ASSISTANT:FAIL_RUN",
  FINISH_RUN: "AI_CHAT_ASSISTANT:FINISH_RUN",
  RECEIVE_DRAFT_CONFIRMATION: "AI_CHAT_ASSISTANT:RECEIVE_DRAFT_CONFIRMATION",
  REQUEST_CREATE_DRAFT: "AI_CHAT_ASSISTANT:REQUEST_CREATE_DRAFT",
  FINISH_CREATE_DRAFT: "AI_CHAT_ASSISTANT:FINISH_CREATE_DRAFT",
  FAIL_CREATE_DRAFT: "AI_CHAT_ASSISTANT:FAIL_CREATE_DRAFT"
};

export class RequestAiAssistantRun {
  public type: string = ACTION.REQUEST_RUN;
}

export class FailAiAssistantRun {
  public type: string = ACTION.FAIL_RUN;
  constructor(public errorMessage: string) { }
}

export class FinishAiAssistantRun {
  public type: string = ACTION.FINISH_RUN;
}

export class ReceiveDraftConfirmation {
  public type: string = ACTION.RECEIVE_DRAFT_CONFIRMATION;
  constructor(public draft: any) { }
}

export class RequestCreateDraft {
  public type: string = ACTION.REQUEST_CREATE_DRAFT;
}

export class FinishCreateDraft {
  public type: string = ACTION.FINISH_CREATE_DRAFT;
}

export class FailCreateDraft {
  public type: string = ACTION.FAIL_CREATE_DRAFT;
  constructor(public errorMessage: string) { }
}
